import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import RangeDatePicker from 'screens/common/RageDatePicker';

function DateRangeSelector({
  selectedRange,
  setSelectedRange,
  handleDateChange,
  styleWidth
}) {
  const options = [
    { value: 'today', label: 'Today' },
    { value: 'this_week', label: 'This Week' },
    { value: 'this_month', label: 'This Month' },
    { value: 'this_year', label: 'This Year' },
    { value: 'custom', label: 'Custom' }
  ];

  let tempStartDate, tempEndDate;

  // Function to handle the date selection
  const handleSelect = selectedOption => {
    setSelectedRange(selectedOption);
    const today = new Date();

    switch (selectedOption.value) {
      case 'today':
        tempStartDate = tempEndDate = today;
        break;

      case 'this_week':
        tempStartDate = new Date(today);
        tempStartDate.setDate(today.getDate() - today.getDay()); // Start of the week (Sunday)
        tempEndDate = new Date(today);
        tempEndDate.setDate(tempStartDate.getDate() + 6); // End of the week (Saturday)
        break;

      case 'this_month':
        tempStartDate = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the month
        tempEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the month
        break;

      case 'this_year':
        tempStartDate = new Date(today.getFullYear(), 0, 1); // First day of the year
        tempEndDate = new Date(today.getFullYear(), 11, 31); // Last day of the year
        break;

      case 'custom':
        return; // No predefined range for custom selection

      default:
        console.log('Invalid selection');
        return;
    }
    handleDateChange(tempStartDate, 'start_date');
    handleDateChange(tempEndDate, 'end_date');
  };

  useEffect(() => {
    handleSelect(selectedRange);
  }, [selectedRange]);

  // Function to handle the custom date range
  const handleDateRangeChange = (start, end) => {
    if ((start && end) || (start === '' && end === '')) {
      tempStartDate = start;
      tempEndDate = end;
      handleDateChange(tempStartDate, 'start_date');
      handleDateChange(tempEndDate, 'end_date');
    }
  };

  return (
    <div className="d-flex align-items-center">
      {/* Select Dropdown with fixed width */}
      <div style={{ width: '200px' }}>
        <Select
          classNamePrefix="react-select"
          value={selectedRange}
          onChange={handleSelect}
          options={options}
          className="w-100"
          isSearchable={false}
          placeholder="Select a date range"
        />
      </div>

      {/* Show RangeDatePicker only when "Custom" is selected */}
      {selectedRange.value === 'custom' && (
        <div className="ms-3 mt-2 flex-grow-1">
          <RangeDatePicker
            onDateChange={handleDateRangeChange}
            noLabel={true}
            styleWidth={styleWidth}
          />
        </div>
      )}
    </div>
  );
}

// Add PropTypes validation for the props
DateRangeSelector.propTypes = {
  selectedRange: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  setSelectedRange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  styleWidth: PropTypes.bool
};

export default DateRangeSelector;
